import yup from '../../../config/yup';

export const printValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('print'),
  action: yup.string().default('PRINT').required('Action is required'),
  command: yup
    .string()
    .default('PRINT')
    .required('Command is required')
    .matches(/^PRINT\s+\S+/i, "Command must start with 'PRINT' followed by at least one word"),
});
